<template>
  <div class="users">
    <div class="users-list panel list-panel">
      <el-container>
        <el-header class="clearfix">
          <h2 class="card-title">Users</h2>
          <el-button class="header-btn pull-right"
                     type="primary"
                     icon="el-icon-circle-plus"
                     @click="createUser"
                     v-if="isAdmin"> Create New User</el-button>
          <div class="search-bar pull-right">
            <el-input placeholder="Search..." v-model="searchTerm" />
          </div>
        </el-header>
        <el-main>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span><b>All Users</b></span>
            </div>
            <div class="list-group">
              <el-button plain
                         :key="user.id"
                        v-for="user in usersFiltered"
                        @click="gotoUser(user)"
                        :type="(user.status === 0) ? 'info' : ''"
                        class="user-list-item list-item">
                <div class="list-item-btn">
                  <client-code v-if="!user.icon" :code="user.first_name.substr(0, 1).toUpperCase() + user.last_name.substr(0, 1).toUpperCase()" :seed="user.first_name" />
                  <img v-if="user.icon" :src="user.icon_url" class="client-code"/>
                  <div class="info">

                    <div :class="{ 'inactive': (user.status === 0) }">{{ user.first_name }} {{ user.last_name }}</div>
                    <div class="created-at">Created {{ user.created_at | localiseUTCDate }}</div>
                  </div>
                  <i class="el-icon-caret-right pull-right icon" />
                </div>
              </el-button>
            </div>
          </el-card>
          <el-card class="box-card" v-if="!usersFiltered.length">
            <div slot="header" class="clearfix">
              <span><b>No Users Found!</b></span>
            </div>
          </el-card>
        </el-main>
      </el-container>
      <user-crud v-if="showUserCrud"
                 :user="editUser"
                 @close="userCrudClose" />
    </div>
  </div>
</template>

<script>
  import firstBy from 'thenby'
  import { mixin as Utils } from '../../mixins/Utils'
  export default {
    name: 'users',
    mixins: [Utils],
    data () {
      return {
        showUserCrud: false,
        searchTerm: ''
      }
    },
    methods: {
      createUser () {
        this.editUser = null
        this.showUserCrud = true
      },
      gotoUser (user) {
        this.$router.push({name: 'user', params: { user_id: user.id }})
      },
      userCrudClose () {
        // Handle the User Crud Dialog closing
        this.showUserCrud = false
      }
    },
    computed: {
      // Vuex Mappings
      users () {
        // Convert the Store object to an array for the UserList component
        let users = Object.keys(this.$store.state.users.objects).map((k) => this.$store.state.users.objects[k])
        return users.sort((a, b) => {
          if (a.first_name < b.first_name) return -1
          if (a.first_name > b.first_name) return 1
          return 0
        })
      },
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      usersFiltered () {
        return this.users.filter((user) => {
          if (this.searchTerm !== '') {
            if (user.first_name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              user.last_name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              user.position.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              user.role.toLowerCase().includes(this.searchTerm.toLowerCase())) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        }).sort(
          firstBy('status', -1).thenBy('first_name')
        )
      }
    },
    mounted () {
      this.$store.dispatch('setPageTitle', 'Users')
      setTimeout(() => {
        this.$store.dispatch('getUsers')
      }, 500)
    }
  }
</script>
<style lang="less" rel="stylesheet/less" scoped>
</style>
